import React from "react";
import NumberDetails from "../components/NumberDetails/NumberDetails";
import UrlTooltip from "../components/UrlTooltip";
import { Link } from "react-router-dom";
import s from './Resend.module.scss'


const LeadItem = React.memo(({ lead, index, handleDelete, sendLeadNow }) => {
    const [isSending, setIsSending] = React.useState(false);

    const handleSendNow = async () => {
        setIsSending(true);
        await sendLeadNow(lead.id);
        setIsSending(false);
    };

    const detailsHandler = (lead) => {
        const partners = {
            'axela': 'message-warning',
            'cpabandtracker': 'message-info',
            'aivix': 'message-danger',
            'cryp.im': 'message-attantion',
            'trump': 'message-dark'
        }
        return partners[lead] || ''
    }

    const roadToPartnerHandler = (road) => {
        const partners = {
            'axela': 'axela',
            'conversion': 'cpabandtracker',
            'aivix': 'aivix',
            'cpabandtracker': 'cryp.im',
            'trump': 'trump'
        }

        return partners[road] || road
    }


    return (<div style={{ "gridTemplateColumns": `25px 40px 90px repeat(4,minmax(100px, 1fr)) 200px 100px 90px 120px`, padding: '8px 0' }}>
        <div onDoubleClick={() => handleDelete(lead.id)} style={{ color: 'red', cursor: 'pointer' }}>✕</div>
        <div>{index + 1}</div>
        <div>{new Date(lead['createdAt']).toLocaleString('uk-UA')}</div>
        <div>{lead['first_name']}</div>
        <div>{lead['last_name']}</div>
        <div>{lead['email']}</div>
        <div><NumberDetails phoneNumber={lead['phone']} /></div>
        <div style={{
            maxHeight: 25,
            overflow: 'hidden',
            position: 'relative',
        }}> <UrlTooltip url={lead['ref']} />
        </div>
        <div>
            {lead['Link'] ? (
                <Link to={`/offers/${lead['Link'].OfferId}/add?search=${lead['Link'].name}`} >{lead['Link'].name}</Link>
            ) : '-'}
        </div>
        <div className={`message ${detailsHandler(lead?.Link?.Offer?.Partner?.name || '')}`} style={{ margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={`${lead?.Link?.Offer?.Partner?.name ?? ''}`}>{lead?.Link?.Offer?.Partner?.name ?? ''}</div>
        <div>
            <button onClick={handleSendNow} className="btn btn-success" disabled={isSending}>
                {isSending ? 'Sending...' : 'Send Now'}
            </button>
        </div>
        <div className={s.transferWrap}>
            <div className={`message message-dark`} style={{ marginBottom: '2px' }}>
                <span>{lead.send_time_from} - {lead.send_time_to} → {roadToPartnerHandler(lead.action)}</span>
            </div>
        </div>

    </div>)
})

export default LeadItem;
